export default "__VITE_ASSET__c5720b48__"